import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { NotPermissionComponent } from '../../not-permission/not-permission.component';
import { Permission } from './../../../../models/auth/Role.class';
import { User } from './../../../../models/auth/User.class';
import { UserPermissions } from './../../../../models/auth/UserPermissions.enum';
import { GlobalService } from './../../../../services/common/global.service';
import { AppConstants } from '../../../../shared/AppConstants';

@Component({
  selector: 'app-roles-configuration',
  templateUrl: './roles-configuration.component.html',
  styleUrls: ['./roles-configuration.component.css'],
})
export class RolesConfigurationComponent implements OnInit {
  saveNewRole: number;
  private userLogged: User;
  private permissions: Permission[] = [];
  havePermission = true;
  havePermissionWrite = true;
  havePermissionRead = true;

  constructor(
    private globalService: GlobalService,
    private messageService: MessageService,
    private translateService: TranslateService,
    public dialog: MatDialog
  ) {
    this.userLogged = this.globalService.getUser();
    this.permissions = this.userLogged?.permissions;
  }

  ngOnInit(): void {
    if (!this.permissions?.map((permission) => permission.name).includes(UserPermissions.Roles)) {
      this.havePermission = false;
      this.messageService.clear(AppConstants.MESSAGE_POSITION_BOTTOM_CENTER);
      this.messageService.add({
        key: AppConstants.MESSAGE_POSITION_BOTTOM_CENTER,
        severity: 'warn',
        summary: this.translateService.instant('Warning'),
        detail: this.translateService.instant('You do not have the necessary permissions in configuration roles'),
      });
      this.dialog.open(NotPermissionComponent, { disableClose: true });
    }

    this.havePermissionWrite =
      this.permissions?.find((permission) => permission.name == UserPermissions.Roles && permission.type == 'WRITE') !==
      undefined;

    this.havePermissionRead = this.permissions?.find(
      (permission) => permission.name == UserPermissions.Roles && permission.type == 'READ'
    )
      ? true
      : this.havePermissionWrite;
  }

  getSaveNewRole(evt): void {
    this.saveNewRole = evt;
  }
}
